const SESSION_KEY = "youvoice-launch-open-v1";

function detectSource() {
  if (typeof window === "undefined") return "direct";
  try {
    const url = new URL(window.location.href);
    const from = String(url.searchParams.get("from") || "").toLowerCase();
    if (from === "youvoice-social") return "youvoice-social";
    if (url.searchParams.get("post") || url.searchParams.get("topic")) return "shared-link";

    const referrer = document.referrer ? new URL(document.referrer) : null;
    if (referrer?.hostname === "youvoice.social" || referrer?.hostname === "www.youvoice.social") {
      return "youvoice-social";
    }
    if (referrer && referrer.origin !== window.location.origin) return "external";
  } catch {
    // Il tracciamento non deve mai interferire con l'app.
  }
  return "direct";
}

export function trackLaunchOpen() {
  if (typeof window === "undefined") return;
  try {
    if (window.sessionStorage.getItem(SESSION_KEY) === "1") return;
    window.sessionStorage.setItem(SESSION_KEY, "1");

    void fetch("/api/v1/launch-analytics/open", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: detectSource() }),
      keepalive: true,
      credentials: "same-origin",
    }).catch(() => {
      // Telemetria best-effort: un errore non deve bloccare alcuna funzione.
    });
  } catch {
    // sessionStorage o fetch possono essere disabilitati: l'app continua normalmente.
  }
}
